import { useRef, useEffect } from 'react';

// This hook returns the value from the previous render - NOTE: this can be the same as the current value
export const usePrevious = <TValue>(value: TValue) => {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef<TValue>();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
};
